import { apiClient, Auth, Pagination } from '@/shared/api'

import {
  TContractActionType,
  TMasterContractStatus,
  THostMasterContract,
} from '../model/schema'

export type HostMasterContractsSearchParams = {
  contractMasterStatus?: TMasterContractStatus
  fromStartDate?: string
  toStartDate?: string
  fromEndDate?: string
  toEndDate?: string
  roomNameOrAddress?: string
  hostContractActionType?: TContractActionType
  page: number
  size: number
}

export const getHostMasterContracts = async (
  params: HostMasterContractsSearchParams,
) => {
  const response = await apiClient.get<Pagination<THostMasterContract>>({
    endpoint: `/v2/host/contracts/masters`,
    queryParams: params,
    auth: Auth.REQUIRED,
  })

  return response
}
